// display bytes in mb or gb
export const formatBytes = (bytes: number) => {
  const mb = bytes / 1024 / 1024;
  if (mb >= 1024) return `${(mb / 1024).toFixed(2)} GB`;
  if (bytes > 0 && mb < 1) return '< 1 MB';
  return `${mb.toFixed(0)} MB`;
};
